import { Screen } from '@bonanza-social/navigation';
import { Box } from '@bonanza-social/moonlight';
import Registration from '../../components/Registration/Registration';
import { Platform } from 'react-native';

function RegistrationScreen() {
  return (
    <Screen paddingHorizontal="space-0">
      <Box
        flex={1}
        paddingTop={Platform.select({
          ios: 'space-0',
          web: 'space-0',
          android: 'safe-area-inset-top',
        })}
      >
        <Registration />
      </Box>
    </Screen>
  );
}
export default RegistrationScreen;
